import './default/index';
import './languages';
import './expand-elements';
import './navigation';
import './popup';
import './waypoint';
import './slider';
import './accordion';
import './subscribe';
import './insta-feed';
import './ajax-posts';
import './change-image';
import './waypoint';
import './trigger-events';
import './table';
import './ie-scroll-fix';
import './customTabs';
import './product';
import './map';



// WEBPACK FOOTER //
// ./../src/assets/js/main.js